import { GAEvent } from '@/services/ga-tracking';

export const handleClickEspInsta = () => {
  window.open('https://www.instagram.com/yego_es/', '_blank', 'noopener,noreferrer');
  GAEvent('ESP INSTA', 'Cliked on Instagram Esp', 'FOOTER_ESP_INSTA');
};
export const handleClickFraInsta = () => {
  window.open('https://www.instagram.com/yego_fr/', '_blank', 'noopener,noreferrer');
  GAEvent('FRA INSTA', 'Cliked on Instagram Fra', 'FOOTER_FRA_INSTA');
};
export const handleClickItaInsta = () => {
  window.open('https://www.instagram.com/yego_italia/', '_blank', 'noopener,noreferrer');
  GAEvent('ITA INSTA', 'Cliked on Instagram Ita', 'FOOTER_ITA_INSTA');
};

const handleClickCareer = () => {
  window.open('https://yego.teamtailor.com/jobs', '_blank', 'noopener,noreferrer');
  GAEvent('CAREER', 'Cliked on Career link', 'FOOTER_CAREER');
};

const handleClickAboutUs = () => {
  window.open('https://yego.teamtailor.com/', '_blank', 'noopener,noreferrer');
  GAEvent('ABOUT US', 'Cliked on About Us link', 'FOOTER_ABOUT');
};

const pdfUrlBase = 'https://www.rideyego.com';

const handleClickPolicy = (lang: string) => {
  const url = `${pdfUrlBase}/${lang}/legal/privacy`;
  window.open(url, '_blank', 'noopener,noreferrer');
  GAEvent('PRIVACY POLICY', 'Cliked on Privacy Policy link', 'FOOTER_PRIVACY_POLICY');
};

const handleClickConditions = (lang: string) => {
  const url = `${pdfUrlBase}/${lang}/legal/terms`;
  window.open(url, '_blank', 'noopener,noreferrer');
  GAEvent('TERMS CONDITIONS', 'Cliked on Terms Conditions link', 'FOOTER_TERMS_CONDITIONS');
};

export const handleClickDownloadAndroid = () => {
  GAEvent('DOWNLOAD_ANDROID', 'Cliked on download app android button', 'FOOTER_DOWNLOAD_ANDROID');
};

export const handleClickDownloadApple = () => {
  GAEvent('DOWNLOAD_APPLE', 'Cliked on download app apple button', 'FOOTER_DOWNLOAD_APPLE');
};

export const handleClickCookies = (lang: string) => {
  const url = `${pdfUrlBase}/${lang}/legal/cookies`;
  window.open(url, '_blank', 'noopener,noreferrer');
  GAEvent('COOKIE POLICY', 'Cliked on Cookie Policy link', 'FOOTER_COOKIE_POLICY');
};

export const YegoOptions = [
  {
    id: 1,
    element: 'button',
    label: 'translation:footer.yego.link.about_us',
    onClick: handleClickAboutUs,
  },
  {
    id: 2,
    element: 'link',
    label: 'translation:footer.yego.link.faq',
    to: '/faq',
  },
  {
    id: 3,
    element: 'anchor',
    label: 'translation:footer.yego.link.gift_card',
    href: 'https://www.rideyego.com/gifts',
  },
  {
    id: 4,
    element: 'button',
    label: 'translation:footer.yego.link.career',
    onClick: handleClickCareer,
  },
  {
    id: 5,
    element: 'button',
    label: 'translation:footer.yego.link.privacy_policy',
    onClick: handleClickPolicy,
  },
  {
    id: 6,
    element: 'button',
    label: 'translation:footer.yego.link.terms_conditions',
    onClick: handleClickConditions,
  },
  {
    id: 7,
    element: 'anchor',
    label: 'translation:footer.yego.link.blog',
    href: 'https://yegomotorclub.com/',
  },
  {
    id: 8,
    element: 'anchor',
    label: 'footer.yego.link.reportChannel',
    href: 'https://sii.horara.es/buzon/empresa-74',
  },
] as const;

export const frenchInfo = [
  {
    id: 1,
    label: 'Règles de stationnement',
    href: 'https://greenriders.rideyego.com/stationnement',
  },
  {
    id: 2,
    label: 'Conseils de conduite',
    href: 'https://greenriders.rideyego.com/conduite',
  },
  {
    id: 3,
    label: 'Consignes de sécurité',
    href: 'https://greenriders.rideyego.com/securite',
  },
  {
    id: 4,
    label: 'Nos engagements environnementaux',
    href: 'https://greenriders.rideyego.com/engagements-environnementaux',
  },
  {
    id: 5,
    label: 'Nos engagements sociétaux',
    href: 'https://greenriders.rideyego.com/engagements-societaux',
  },
];
